var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IndexCard',{attrs:{"title":"专题专栏","to":"/topic"}},[(_vm.categoryTopicList.length <= 3)?_c('div',{staticClass:"list"},_vm._l((_vm.categoryTopicList),function(item,index){return _c('router-link',{key:index + Math.random(),staticClass:"item",attrs:{"target":"_blank","to":{
        name: item.cate_type == 2 ? 'topic_category' : 'topic_list',
        query:
          item.cate_type == 2
            ? {
                id: item.cate_id,
                cate_type: item.cate_type,
                name: item.name,
              }
            : {
                id: item.cate_id,
                cate_type: item.cate_type,
                name: item.name,
              },
      }}},[_c('img',{staticClass:"img",attrs:{"src":_vm._f("baseImg")(item.image)}}),_c('div',{staticClass:"tit"},[_vm._v(_vm._s(item.name))])])}),1):_c('div',{staticClass:"list"},[_c('img',{staticClass:"sss-b",attrs:{"src":require("../../../assets/images/previcon.jpg"),"alt":""},on:{"click":_vm.iaTime}}),_c('div',{staticClass:"sss"},[_c('div',{staticClass:"sss-a",class:{ activeDec: _vm.isActive == 1, activeAbc: _vm.isActive == 2 },style:({
          width: _vm.categoryTopicList.length * 2 * 325 + 'px',
          left: _vm.left_a + 'px',
        }),on:{"mouseover":_vm.mouseOver,"mouseleave":_vm.mouseLeave}},[_vm._l((_vm.categoryTopicList),function(item,index){return _c('router-link',{key:index +Math.random(),staticClass:"item",attrs:{"target":"_blank","to":{
            name: item.cate_type == 2 ? 'topic_category' : 'topic_list',
            query:
              item.cate_type == 2
                ? {
                    id: item.cate_id,
                    cate_type: item.cate_type,
                    name: item.name,
                  }
                : {
                    id: item.cate_id,
                    cate_type: item.cate_type,
                    name: item.name,
                  },
          }}},[_c('img',{staticClass:"img",attrs:{"src":_vm._f("baseImg")(item.image)}}),_c('div',{staticClass:"tit"},[_vm._v(_vm._s(item.name))])])}),_vm._l((_vm.categoryTopicList),function(item,index){return _c('router-link',{key:index +Math.random(),staticClass:"item",attrs:{"target":"_blank","to":{
            name: item.cate_type == 2 ? 'topic_category' : 'topic_list',
            query:
              item.cate_type == 2
                ? {
                    id: item.cate_id,
                    cate_type: item.cate_type,
                    name: item.name,
                  }
                : {
                    id: item.cate_id,
                    cate_type: item.cate_type,
                    name: item.name,
                  },
          }}},[_c('img',{staticClass:"img",attrs:{"src":_vm._f("baseImg")(item.image)}}),_c('div',{staticClass:"tit"},[_vm._v(_vm._s(item.name))])])})],2)]),_c('img',{staticClass:"sss-c",attrs:{"src":require("../../../assets/images/nexticon.jpg"),"alt":""},on:{"click":_vm.iaTime_b}})])])}
var staticRenderFns = []

export { render, staticRenderFns }